import sortBy from 'lodash/sortBy';

import { FillInBlanksSentence } from '../fill-in-blanks.constants';

export function mergeFillInBlanksBlocks(
  sentence: FillInBlanksSentence | undefined
) {
  const textblocks = sentence?.textBlocks || [];
  const answerBlocks = sentence?.answerBlocks || [];
  return sortBy([...textblocks, ...answerBlocks], 'sort');
}
